const navigatorExists = typeof navigator !== 'undefined'

export const isMobile =
  navigatorExists && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
export const isPitcherWkWebView = navigatorExists && navigator.userAgent === 'Pitcher WKWebView'
export const isIosDevice =
  navigatorExists &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
export const isSafariOnIosDevice = !isPitcherWkWebView && isIosDevice
export const isPitcherOrIosDevice = isPitcherWkWebView || isIosDevice
export const isTouchScreen = navigatorExists && navigator.maxTouchPoints > 0
export const isMac = navigatorExists && navigator.userAgent.toLowerCase().includes('mac')
export const isWindows = navigatorExists && navigator.userAgent.toLowerCase().includes('win')
export const isSafari =
  navigatorExists &&
  /Safari/.test(navigator.userAgent) &&
  !/Chrome/.test(navigator.userAgent) &&
  !/Chromium/.test(navigator.userAgent)
export const isFirefox = navigatorExists && navigator.userAgent.toLowerCase().includes('firefox')
